import React, { useMemo, useState, useEffect } from 'react'
import "./autoResult.scss"
import Logo from "./logo-removebg-preview.png"
import { SelectAutoResultData, SelectPreviewsTime } from '../../../redux/2d-slice/gameInfo2dSlice'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

function AutoResult() {
    const navigate = useNavigate()
    const previewsTime = useSelector(SelectPreviewsTime)
    const last_win_cards = useSelector(SelectAutoResultData)

    const [count, setCount] = useState(0)
    const [animation, setAnimation] = useState(true)
    const [timer, setTimer] = useState(10)

    // count animation
    useEffect(() => {
        setAnimation(true); 
        setCount(0);

        let elapsed = 0;
        const duration = 40 * 1000; // 18 seconds
        const step = 200; // change digit every 200ms → cycles ~9 times in 18s

        const id = setInterval(() => {
            setCount(prev => (prev + 1) % 10); // cycle 0–9
            elapsed += step;

            if (elapsed >= duration) {
                clearInterval(id);
                setAnimation(false);
            }
        }, step);

        return () => {
            clearInterval(id);
            setAnimation(false);
        };
    }, []);

    // timer redirect
    useEffect(() => {
        if (animation) return
        let timerCount = 10
        let id = setInterval(() => {
            setTimer(old => old - 1)
            timerCount = timerCount - 1
            if (timerCount <= 0) {
                clearInterval(id)
                navigate('/2d')
            }
        }, 1000);

        return () => {
            clearInterval(id)
        }
    }, [animation, navigate])

    // safe processing of result data
    const resultCard = useMemo(() => {
        if (last_win_cards && last_win_cards.length >= 3) {
            let wincardObj = last_win_cards[2]
            let resultObj = { 1: [], 3: [], 5: [] }

            Object.keys(wincardObj || {}).forEach((objIndex) => {
                Object.keys(wincardObj[objIndex] || {}).forEach((numberIndex) => {
                    if (resultObj[numberIndex]) {
                        resultObj[numberIndex].push(wincardObj[objIndex][numberIndex])
                    }
                })
            })
            return resultObj
        }
        return { 1: [], 3: [], 5: [] }
    }, [last_win_cards])

    return (
        <div className="auto-result-modal fade bg-black bg-opacity-70">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">

                    {/* header */}
                    <div className="modal-header">
                        <div className="myacc_tab_sec">
                            <button
                                type="button"
                                title="Press Space button to close the popup window"
                                className="btn-close popup-close"
                                data-bs-dismiss="modal"
                                onClick={() => navigate('/2d')}
                            >
                                
                                <img src="/images/close_btn.png" className="popupclose_icon modal_close" alt="close" />
                            </button>

                            <div className='flex justify-center'>
                                <div className='resultLogo flex justify-center'>
                                    Result
                                    {/* <img src={"/images/logo-removebg-preview1.png"} alt="shree raj logo" style={{ width: "120px", height: "100%" }} /> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* body */}
                    <div className="modal-body">
                        {/* timer */}
                        <div className='flex justify-center py-2'>
                            <p className='text-[#ff5722] font-semibold'>
                                RESULT : {previewsTime ? moment(previewsTime, 'D/M/yyyy, h:mm:ss A').format('hh:mm:ss A') : ''} {timer} SEC
                            </p>
                        </div>

                        {/* count container */}
                        <div className='w-full flex'>
                            {/* Silver */}
                            <div className='w-1/3 border-[red] flex flex-wrap justify-center items-center'>
                                {[...Array(10)].map((_, index) => (
                                    <div className={`game_result${index + 1} w-[48%] m-[0.6%] rounded-lg`} key={index}>
                                        <div className='flex items-center justify-between '>
                                            <div className='flex items-center w-full pl-[10%] text-[115%] font-semibold text-center'>
                                                {10 + index}
                                            </div>
                                            <div className='flex p-1 items-center justify-center'>
                                                {(resultCard[1]?.[index]?.slice(2, 4).split('') || ["", ""]).map((digit, digitIndex) => (
                                                    <div
                                                        className="w-[40px] h-[50px] flex items-center justify-center bg-black rounded-lg ml-[3px] text-[220%] font-normal text-white"
                                                        key={digitIndex}
                                                    >
                                                        {animation ? count : digit}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Gold */}
                            <div className='w-1/3 border-[red] flex flex-wrap justify-center items-center'>
                                {[...Array(10)].map((_, index) => (
                                    <div className={`game_result${index + 1} w-[48%] m-[0.6%] rounded-lg`} key={index}>
                                        <div className='flex items-center justify-between '>
                                            <div className='flex items-center w-full pl-[10%] text-[115%] font-semibold text-center'>
                                                {30 + index}
                                            </div>
                                            <div className='flex p-1 items-center justify-center'>
                                                {(resultCard[3]?.[index]?.slice(2, 4).split('') || ["", ""]).map((digit, digitIndex) => (
                                                    <div
                                                        className='w-[40px] h-[50px] flex items-center justify-center bg-black rounded-lg ml-[3px] text-[220%] font-normal text-white'
                                                        key={digitIndex}
                                                    >
                                                        {animation ? count : digit}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Diamond */}
                            <div className='w-1/3 border-[red] flex flex-wrap justify-center items-center'>
                                {[...Array(10)].map((_, index) => (
                                    <div className={`game_result${index + 1} w-[48%] m-[0.6%] rounded-lg`} key={index}>
                                        <div className='flex items-center justify-between '>
                                            <div className='flex items-center w-full pl-[10%] text-[115%] font-semibold text-center'>
                                                {50 + index}
                                            </div>
                                            <div className='flex p-1 items-center justify-center'>
                                                {(resultCard[5]?.[index]?.slice(2, 4).split('') || ["", ""]).map((digit, digitIndex) => (
                                                    <div
                                                        className='w-[40px] h-[50px] flex items-center justify-center bg-black rounded-lg ml-[3px] text-[220%] font-normal text-white'
                                                        key={digitIndex}
                                                    >
                                                        {animation ? count : digit}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AutoResult
